import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import StandardLayout from '../../templates/StandardLayout';
import PageDescription from '../../organisms/PageDescription';

const AboutComponent = ({ sectionHeadings }) => (
  <StandardLayout>
    <div className="about">
      <div className="main-hero-section">
        <div className="main-hero-heading">
          <PageDescription
            heading={R.path(['pageHeaderSection', 'heading'], sectionHeadings)}
            text={R.path(
              ['pageHeaderSection', 'introduction'],
              sectionHeadings
            )}
          />
        </div>
        <div className="grid-container">
          <div className="grid-x">
            <div className="cell xsmall-16">
              <div className="about__hero-main">
                <HeroFullBlock
                  layout="vertical"
                  heroStoreDataKey="hero1"
                  isUnderlined={false}
                  headingLevel={1}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid-container">
        <div className="grid-x">
          <div className="cell xsmall-16 large-12 large-offset-2">
            <div className="about__hero about__hero-image-first">
              <HeroFullBlock
                heroStoreDataKey="hero2"
                isUnderlined={false}
                headingLevel={3}
              />
            </div>

            <div className="about__hero about__hero-image-last">
              <HeroFullBlock
                heroStoreDataKey="hero3"
                isUnderlined={false}
                headingLevel={3}
                isContentFirst
              />
            </div>

            <div className="about__hero about__hero-image-first">
              <HeroFullBlock
                extraClass="about__hero about__hero-image-first"
                heroStoreDataKey="hero4"
                isUnderlined={false}
                headingLevel={3}
                ctaType="button"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

AboutComponent.propTypes = {
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
};

export default connect(({ content }) => ({
  sectionHeadings: R.prop('sectionHeadings', content),
}))(AboutComponent);
